// Bearsign returns job_level as { name, short_name } (optional ulid).
// Modes: short = short_name || name; long = name; combined = "Name (short)".
// Legacy string values are returned as-is.
export const formatJobLevel = (jobLevel, { mode = 'short' } = {}) => {
  if (jobLevel == null || jobLevel === '') return '';

  if (typeof jobLevel === 'string') return jobLevel;

  if (typeof jobLevel !== 'object') return '';

  const name = typeof jobLevel.name === 'string' ? jobLevel.name.trim() : '';
  const shortName = typeof jobLevel.short_name === 'string'
    ? jobLevel.short_name.trim()
    : '';

  if (mode === 'long') {
    return name || shortName;
  }

  if (mode === 'combined') {
    if (name && shortName) return `${name} (${shortName})`;
    return name || shortName;
  }

  // short (default): prefer alias, fall back to full name
  return shortName || name;
};
